var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossOut = function SvgCrossOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "100%",
      height: "100%"
    }
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: "100%",
    y2: "100%",
    stroke: "currentColor"
  })));
};
export { SvgCrossOut as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBzdHlsZT0nd2lkdGg6IDEwMCU7IGhlaWdodDogMTAwJTsnPgogICAgPGxpbmUgeDE9IjEwMCUiIHkyPSIxMDAlIiB4Mj0iMCIgeTE9IjAiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2VXaWR0aD0iMSIvPgo8L3N2Zz4=";